import cx from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import classes from "./toolbar-button-separator-scss.js";
const ToolbarButtonSeparator = () => {
  const { isMobile } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement("div", { className: cx(classes.separator, { [classes.mobileSeparator]: isMobile }) });
};
export {
  ToolbarButtonSeparator
};
//# sourceMappingURL=toolbar-button-separator.js.map
